import { EmptyState, Loading, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import useEffectOnce from '../../hooks/useEffectOnce';
import { useStyles } from '../../hooks/useStyles';
import {
  fenceIdsState,
  fencesPageState,
  fencesState,
  loadingFencesState,
  selectedFenceIdState,
} from '../../storage/fences';
import { Fence } from '../../types/fence';
import { FloatingCardContent } from '../layout/cards/FloatingCardContent';
import { VirtualizedPaginatedList } from '../shared/VirtualizedPaginatedList';
import FenceFilters from './FenceFilters';
import FenceItem from './FenceItem';

export function FenceList() {
  const { theme } = useStyles();
  const fenceIds = useRecoilValue(fenceIdsState);
  const setSelectedFenceId = useSetRecoilState(selectedFenceIdState);
  const resetSelectedFenceId = useResetRecoilState(selectedFenceIdState);
  const loadingFences = useRecoilValue(loadingFencesState);
  const paginatedFences = useRecoilValue(fencesState);
  const setFencesPage = useSetRecoilState(fencesPageState);

  useEffectOnce(() => {
    return () => {
      resetSelectedFenceId();
    };
  });

  const onNewFence = () => {
    setSelectedFenceId('');
  };

  return (
    <FloatingCardContent
      flexible
      gap={theme.sizing.scale600}
    >
      {!fenceIds && !loadingFences && <EmptyState title="Todavía no creas ningun geocerco" />}
      {!fenceIds && loadingFences && <Loading />}
      {fenceIds && (
        <>
          <FenceFilters />
          <VirtualizedPaginatedList<Fence>
            ids={fenceIds}
            loading={loadingFences}
            onNextPage={setFencesPage}
            paginatedResponse={paginatedFences}
            itemComponent={FenceItem}
          />
          {!fenceIds.length && (
            <EmptyState
              title="No se encontraron resultados"
              description="Intenta con otra busqueda"
            />
          )}
        </>
      )}
      {(fenceIds || !loadingFences) && (
        <StyledButton
          size="compact"
          shape="square"
          onClick={onNewFence}
          startEnhancer={<MaterialIcon name={'add'} />}
          kind="tertiary"
        >
          Nuevo cerco
        </StyledButton>
      )}
    </FloatingCardContent>
  );
}
